module.exports = __webpack_public_path__ + "img/Ayudantes-portada2.46e32d15.webp";